export const PUBLIC_SETTINGS_PATH = '/public/settings';

export const publicStringsPath = (locale: string) => `/public/strings/${locale}`;
